let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lVJBC")).then(() => parcelRequire('etwz7'));